// ** React Imports
import { useSkin } from '@hooks/useSkin';
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';

// ** Third Party Components
import { Disc, X, Circle } from 'react-feather';

// ** Config
import themeConfig from '@configs/themeConfig';

const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setMenuCollapsed,
    setMenuVisibility,
    setGroupOpen,
    menuHover,
  } = props;

  const [skin] = useSkin();

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed]);

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(true)}
        />
      );
    } else {
      return (
        <Circle
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(false)}
        />
      );
    }
  };

  return (
    <div className='navbar-header' style={{ minHeight: '105px' }}>
      <ul className='nav navbar-nav flex-row'>
        <li className='nav-item m-auto'>
          <NavLink to='/' className='navbar-brand'>
            <img
              id={`tooltip-brand`}
              src={
                skin === 'light'
                  ? themeConfig.app.appLogoImageDark
                  : themeConfig.app.appLogoImageLight
              }
              alt={themeConfig.app.appName}
              height='auto'
              style={{ maxWidth: '100%', maxHeight: '50px' }}
            />
          </NavLink>
          <UncontrolledTooltip target={`tooltip-brand`}>
            Star Atlas Explorer
          </UncontrolledTooltip>
        </li>
      </ul>
    </div>
  );
};

export default VerticalMenuHeader;
